// https://github.com/alinemorelli/react-gtm
import Snippets from './snippets';
import { GLOBALS } from "../globals";

const GoogleTagManager = {
  gtm: function (args: object) {
    const snippets = Snippets.tags(args);

    const script1 = () => {
      const script = document.createElement('script');
      script.innerHTML = snippets.script1;
      return script;
    };

    const script2 = () => {
      const script = document.createElement('script');
      script.src = "https://www.googletagmanager.com/gtag/js?id=" + GLOBALS.gtm;
      return script;
    };

    return {
      script1,
      script2
    };
  },

  init: function ({
    gtmId,
    events = {},
  }: any) {
    const gtm = this.gtm({
      id: gtmId,
      events: events,
    });

    document.head.insertBefore(gtm.script1(), document.head.childNodes[0]);
    document.head.insertBefore(gtm.script2(), document.head.childNodes[0]);
  }
};

export default GoogleTagManager;
